import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useCollaborationSidebarHasUnrecoverableError } from 'collaboration-sidebar/public/hooks/useCollaborationSidebarHasUnrecoverableError';
import { jsx as _jsx } from "react/jsx-runtime";
function ApprovalAvailabilityTooltip({
  children
}) {
  const {
    hasUnrecoverableError
  } = useCollaborationSidebarHasUnrecoverableError();
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !hasUnrecoverableError,
    placement: "left",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "approvals.approvalsUnavailableTooltip"
    }),
    children: children
  });
}
export default ApprovalAvailabilityTooltip;